module.exports = __webpack_public_path__ + "static/img/92093DQ_1_C_20210404_LC.40f7226.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/92093DQ_1_C_20210404_LC.png
// module id = f68J
// module chunks = 0